import { BillSource } from "../../../types/bill";

const RAMP_BILLS_BASE_URL = "https://app.ramp.com/bill-pay/bills";

interface BillExternalUrlParams {
    bill: {
        source: BillSource;
        sourceId: string | null;
    };
    billcomBaseUrl: string;
}

export function getBillExternalUrl({
    bill,
    billcomBaseUrl,
}: BillExternalUrlParams): string {
    if (!bill.sourceId) {
        return "";
    }

    if (bill.source === BillSource.RAMP) {
        return `${RAMP_BILLS_BASE_URL}/overview/bills/${bill.sourceId}`;
    }

    if (bill.source === BillSource.BILLCOM) {
        return `${billcomBaseUrl}/neo/bills/${bill.sourceId}`;
    }

    return "";
}
